import { defineComponent as _defineComponent } from 'vue'
import { ProfileStoreKey } from '@/models/Profile';
import useProfileState from '@/state/profile/profileState';
import ProfileSection from '@/views/profile/components/ProfileSection.vue';
import ProfileBasicEditor from '@/views/profile/components/editors/ProfileBasicEditor.vue';
import ProfileCertificatesEducationsEditor from '@/views/profile/components/editors/ProfileCertificatesEducationsEditor.vue';
import ProfilePreferencesEditor from '@/views/profile/components/editors/ProfilePreferencesEditor.vue';
import ProfileProjectsEditor from '@/views/profile/components/editors/ProfileProjectsEditor.vue';
import ProfileReferencesEditor from '@/views/profile/components/editors/ProfileReferencesEditor.vue';
import ProfileSkillsEditor from '@/views/profile/components/editors/ProfileSkillsEditor.vue';
import ProfileBasicView from '@/views/profile/components/views/ProfileBasicView.vue';
import ProfileCertificatesEducationsView from '@/views/profile/components/views/ProfileCertificatesEducationsView.vue';
import ProfileInvitedBy from '@/views/profile/components/views/ProfileInvitedBy.vue';
import ProfilePreferencesView from '@/views/profile/components/views/ProfilePreferencesView.vue';
import ProfileProjectsView from '@/views/profile/components/views/ProfileProjectsView.vue';
import ProfileReferencesView from '@/views/profile/components/views/ProfileReferencesView.vue';
import ProfileSkillsView from '@/views/profile/components/views/ProfileSkillsView.vue';
import ProfilePdfUploadBanner from '@/views/profile/components/profile-pdf-upload/ProfilePdfUploadBanner.vue';
import ProfilePdfUploadPopup from '@/views/profile/components/profile-pdf-upload/ProfilePdfUploadPopup.vue';
import useProfilePreview from '@/state/profile/profilePreview';
import useProfilePdfUploadPopup from '@/views/profile/composables/useProfilePdfUploadPopup';
import {
  computed, inject, onMounted,
} from 'vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import { useStore } from 'vue2-helpers/vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileFreelancer',
  setup(__props) {

const {
  isSelf, isEditSectionOpen, isSectionFilled, isQuickInfo, canEdit,
} = useProfileState(ProfileStoreKey.PROFILE);

const { hasAnyUnresolved } = useProfilePreview();
const { isBannerDismissed, resetBannerDismissed } = useProfilePdfUploadPopup();
const { isMobileWidth } = useResponsiveness();
const breadcrumbs = inject('breadcrumbs', []);
const store = useStore();

const showPdfUploadBanner = computed(() => {
  if (!canEdit.value || !store.state.dashboard.userProfileStatusLoaded || isBannerDismissed.value) return false;

  return true;
});

const pdfUploadBannerTitleKey = computed(() => {
  const {
    missingSummary,
    missingSkills,
    missingExperiences,
  } = store.state.dashboard.userProfileStatus;

  return missingSummary || missingSkills || missingExperiences
    ? 'profilePdfUpload.banner.title'
    : 'profilePdfUpload.banner.updateTitle';
});

onMounted(() => {
  resetBannerDismissed();
  store.dispatch('dashboard/fetchDashboardUserProfileStatus');
});

return { __sfc: true,isSelf, isEditSectionOpen, isSectionFilled, isQuickInfo, canEdit, hasAnyUnresolved, isBannerDismissed, resetBannerDismissed, isMobileWidth, breadcrumbs, store, showPdfUploadBanner, pdfUploadBannerTitleKey, ProfileSection, ProfileBasicEditor, ProfileCertificatesEducationsEditor, ProfilePreferencesEditor, ProfileProjectsEditor, ProfileReferencesEditor, ProfileSkillsEditor, ProfileBasicView, ProfileCertificatesEducationsView, ProfileInvitedBy, ProfilePreferencesView, ProfileProjectsView, ProfileReferencesView, ProfileSkillsView, ProfilePdfUploadBanner, ProfilePdfUploadPopup, BCXContentArea, BCXBreadcrumbs }
}

})